var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9883 0.689453C14.471 0.689453 9.96094 5.19956 9.96094 10.7168C9.96094 16.2341 14.471 20.7442 19.9883 20.7442C25.5056 20.7442 30.0157 16.2341 30.0157 10.7168C30.0157 5.19956 25.5056 0.689453 19.9883 0.689453Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1955 28.7574C36.9328 28.1005 36.5825 27.4875 36.1884 26.9183C34.1742 23.9407 31.0653 21.9702 27.5623 21.4886C27.1245 21.4448 26.6428 21.5323 26.2925 21.7951C24.4534 23.1525 22.264 23.8531 19.987 23.8531C17.71 23.8531 15.5207 23.1525 13.6816 21.7951C13.3312 21.5323 12.8496 21.401 12.4117 21.4886C8.90872 21.9702 5.75604 23.9407 3.78562 26.9183C3.39153 27.4875 3.0412 28.1444 2.77853 28.7574C2.64719 29.0201 2.69094 29.3266 2.82228 29.5894C3.17261 30.2024 3.61045 30.8155 4.00453 31.3409C4.61754 32.1729 5.27437 32.9172 6.01879 33.6178C6.6318 34.2308 7.33238 34.8001 8.03305 35.3693C11.4922 37.9528 15.6521 39.3102 19.9433 39.3102C24.2345 39.3102 28.3943 37.9528 31.8535 35.3693C32.5541 34.8439 33.2547 34.2308 33.8678 33.6178C34.5683 32.9172 35.2689 32.1728 35.882 31.3409C36.3199 30.7716 36.714 30.2024 37.0643 29.5894C37.2831 29.3266 37.3269 29.02 37.1955 28.7574Z",
    fill: "#3C3C3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6207,
    height: 38.6207,
    fill: "white",
    transform: "translate(0.671875 0.689453)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.9c5c3d8c511d6b3cd0d52577db6624f8.svg";
export { ForwardRef as ReactComponent };